// extracted by mini-css-extract-plugin
export default {"reviewBatch":"InReviewCard_reviewBatch__lPaui"};